import { cva } from "./index.ts";

export const radiobutton = cva({
  base: "appearance-none box-content rounded-full border border-primary align-bottom before:content-[' '] checked:bg-primary before:bg-hazel-500 before:block before:scale-0 checked:before:scale-[1] before:transition transition before:h-1/2 before:w-1/2 before:rounded-full flex items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  variants: {
    size: {
      sm: "h-3 w-3",
      md: "h-4 w-4",
      lg: "h-5 w-5",
    },
  },
});
